export default "__VITE_ASSET__wWe8hlUPVVG6fCV2ygwt0w__"